module.exports = __webpack_public_path__ + "static/media/diariovasco.9fa56933.png";